<template>
  <section class="th-features">
    <TwinColorTitle class="title" :width="titleProps?.width">
      <slot name="title" />
    </TwinColorTitle>

    <div class="description" :style="{ maxWidth: descriptionProps?.width }">
      <slot name="description" />
    </div>

    <div class="cta" v-if="hasCta">
      <NavLink :href="Routes.PlanATrip">
        <Button color="red" text="Plan a trip" />
      </NavLink>
    </div>

    <div class="th-features__grid">
      <Card
        :center="true"
        :shadow="false"
        :color="idx % 2 === 0 ? color : 'green'"
        class="th-features__grid-item-card"
        v-for="(reason, idx) in reasons"
        :key="reason.title"
      >
        <h3 class="th-features__grid-item-title" v-html="reason.title" />
        <p class="th-features__grid-item-description">
          {{ reason.description }}
        </p>
      </Card>
    </div>
  </section>
</template>

<script setup lang="ts">
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'
import Card from '@/components/Theme2/Card.vue'
import Button from '@/components/Theme2/Button.vue'
import { Routes } from '@/constants'
import NavLink from '@/components/NavLink.vue'

const props = defineProps<{
  variant: 'primary' | 'secondary'
  reasons: {
    title: string
    description: string
  }[]
  hasCta?: boolean
  titleProps?: {
    width?: string
  }
  descriptionProps?: {
    width?: string
  }
}>()

const color = props.variant === 'primary' ? 'yellow' : 'blue'
</script>

<style lang="scss" scoped>
.th-features {
  @include main-rewrap;
  align-items: center;
  gap: 32px;

  .title {
    font-size: 36px;
    line-height: 40px;
  }

  .description {
    max-width: 690px;
    text-align: center;
    margin: 0 auto;
  }

  .cta {
    text-align: center;
  }
}

.th-features__grid {
  @include mobile {
    @include flex-column;
    gap: 10px;
    text-align: center;
  }

  @include desktop {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
}

.th-features__grid-item-card {
  gap: 20px;
  padding-block: 30px;

  @include desktop {
    padding-block: 40px;
    height: 100%;
  }
}

.th-features__grid-item-title {
  margin: 0;
  font-weight: 600;
  font-size: 30px;
  line-height: 1.2;
}

.th-features__grid-item-description {
  margin: 0;
}
</style>
